import React from 'react';
import { Platform } from 'react-native';

import { Pressable } from '@fhs/ui';

import type { StoreCardFrameProps } from './store-card-frame.types';

/**
 * Kill the 4px outline Pressable always paints — it sits outside the row and reads as a top
 * border. `pointerEvents: none` lets favourite / info / CTA receive taps through that overlay.
 */
const hideOutline = { borderWidth: 0, pointerEvents: 'none' } as const;

/**
 * On native the whole card is the tap target. On web the same Pressable would render as a
 * button and nest the select, `(i)`, favourite, and order controls, so those role/focus
 * props are stripped only on web; keyboard users land on the inner select button instead.
 */
const webA11yProps =
  Platform.OS === 'web'
    ? ({
        accessibilityRole: 'none',
        role: 'none',
        focusable: false,
      } as const)
    : {};

export const StoreCardFrame: React.VFC<StoreCardFrameProps> = ({
  children,
  style,
  hoveredStyle,
  onPress,
  testID,
}) => (
  <Pressable
    testID={testID}
    accessible={false}
    onPress={onPress}
    style={style}
    hoveredStyle={hoveredStyle}
    // Cards are full-bleed rows divided by a hairline, so the focus outline must be square.
    borderRadius={0}
    borderWidth={0}
    outlineStyle={hideOutline}
    outlinePressedStyle={hideOutline}
    outlineFocusedStyle={hideOutline}
    outlineHoveredStyle={hideOutline}
    outlineDisabledStyle={hideOutline}
    {...webA11yProps}
  >
    {children}
  </Pressable>
);
